import { NotificationsTable } from "@features/notifications/components/NotificationsTable";
import { Box } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/notifications")({
    component: NotificationsPage,
    staticData: {
        crumb: { label: "Notifications" },
    },
});

function NotificationsPage() {
    return (
        <Box h="100%" p="xs">
            <NotificationsTable />
        </Box>
    );
}
